export default "__VITE_ASSET__CDTvJFBx__"